import React, { Fragment, useState, useContext, useEffect } from 'react';
import { CartContext } from 'components/cart';
import classNames from 'lib/classNames';



const Announcement = ({announcement}) => {
	const {
		Utils,
        isPreview
	} = useContext(CartContext);


    const textAlignement = {"left": "start", "center": "center", "right": "end"}
    return (
            <div 
                className={classNames('',{
                    ['px-5']: announcement.position === "bellow_header" && announcement.style == "rounded",
                    ['-mx-5']: announcement.position !== "bellow_header" && announcement.style == "full",
                    ['mb-3'] : announcement.position === "above_products" || announcement.position === "above_totals" || announcement.position === "bellow_products" ,
                })}
             >
                <div 
                    className={classNames('px-5 py-2',{["rounded"]:  announcement.style == "rounded",})}
                    style={{
                        fontSize: `${announcement.text.font_size}em`,
                        color: Utils.formatColor(announcement.text.color),
                        background: Utils.formatColor(announcement.background),
                        borderTop: `${Utils.formatColor(announcement.border)} 1px solid`,
                        borderBottom: `${Utils.formatColor(announcement.border)} 1px solid`,
                        borderRight:  announcement.style == "rounded" && `${Utils.formatColor(announcement.border)} 1px solid`,
                        borderLeft:  announcement.style == "rounded" && `${Utils.formatColor(announcement.border)} 1px solid`,
                        textAlign: textAlignement[announcement.textAlignement]
                    }}
                >
                    <span 
                        dangerouslySetInnerHTML={{
                            __html: announcement.text.text,
                        }}
                    />
                </div>
            </div>
    )
}


export default Announcement;